import { Component } from '@verndale/core';
import GlobalNavigation from './GlobalNavigation';
import UtilityNavigation from './UtilityNavigation';

class Header extends Component {
  globalNavigation: GlobalNavigation | null = null;
  utilityNavigation: UtilityNavigation | null = null;

  constructor(el: HTMLElement) {
    super(el);

    if (this.dom.globalNavigation) {
      this.globalNavigation = new GlobalNavigation(
        this.dom.globalNavigation as HTMLElement
      );
    }

    if (this.dom.utilityNavigation) {
      this.utilityNavigation = new UtilityNavigation(
        this.dom.utilityNavigation as HTMLElement
      );
    }
  }

  setupDefaults() {
    this.dom = {
      globalNavigation:
        this.el.querySelector<HTMLElement>('.global-navigation'),
      utilityNavigation: this.el.querySelector<HTMLElement>(
        ':scope > .utility-navigation'
      )
    };
  }
}

export default Header;
